module.exports = __webpack_public_path__ + "static/media/heroImg.53a2d53b.jpg";